import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

const MAX_ITEM_LENGTH: number = 40;

@Pipe({
    name: 'namesList',
    standalone: true
})

export class NamesListPipe implements PipeTransform {

	constructor(private translate: TranslateService) {}

	transform(stands: Array<any>, key: string, windowHeight: number, maxLength: number = 50): string {
		let names: string = '',
			moreStands: string = '';
		const lengthLimit: number = Math.min(Math.floor(windowHeight / 20), maxLength);

		stands = [...stands].sort((a, b) => a[key].toLowerCase().localeCompare(b[key].toLowerCase()));

		if (stands.length > lengthLimit) {
			this.translate
				.get('MORE', { value: stands.length - lengthLimit })
				.subscribe(trans => moreStands = trans);
			stands = stands.slice(0, lengthLimit);
		}

		stands.forEach(planogram => names +=
			(planogram[key].length > MAX_ITEM_LENGTH ?
				planogram[key].slice(0, MAX_ITEM_LENGTH - 3).trim() + '...' :
				planogram[key])
			+ '\n');
		names += moreStands;

		return names;
	}
}